import { useLocation, useParams } from "react-router-dom";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import SearchSection from "./SearchSection";
import { useEffect } from "react";
import { showErrorToast } from "../../utils/notify";

const Filter = ({
  isLoading,
  isError,
  handleSearchChange,
  searchInput,
  dateRange,
  handleTimeSpan,
  handleDateRange,
  timeSpanInput,
  handleDateRangeSubmit,
  isShowDateFilter,
  dataType,
  setDataType,
}) => {
  const location = useLocation();
  const { eventId } = useParams();
  const isMyEarningsPage = location.pathname === "/organizer/myEarning";
  const isPromoterEarningsPage = location.pathname === "/promoter/earning";
  const showEarningsFilters = isMyEarningsPage || isPromoterEarningsPage;
  const isOrganizerEarningDetailPage =
    location.pathname === `/organizer/myEarning/${eventId}`;
  const isPromoterEarningDetailPage =
    location.pathname === `/promoter/earning/${eventId}`;
  const isEarningDetailPage =
    isOrganizerEarningDetailPage || isPromoterEarningDetailPage;

  useEffect(() => {
    if (isError) showErrorToast(isError);
  }, [isError]);

  return (
    <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
      {showEarningsFilters && (
        <form
          className="event-my-earnings-filters"
          onSubmit={handleDateRangeSubmit}
        >
          <div className="event-my-earnings-filters-top">
            <div className="event-my-earnings-date-row">
              <div className="event-my-earnings-field">
                <label
                  className="event-my-earnings-label"
                  htmlFor="eventMyEarningsStartDate"
                >
                  Start Date
                </label>
                <div className="event-my-earnings-date-control">
                  <input
                    id="eventMyEarningsStartDate"
                    className="event-my-earnings-input"
                    type="date"
                    name="startDate"
                    value={dateRange?.startDate || ""}
                    onChange={handleDateRange}
                  />
                  <i
                    className="bi bi-calendar3 event-my-earnings-date-icon"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
              <div className="event-my-earnings-field">
                <label
                  className="event-my-earnings-label"
                  htmlFor="eventMyEarningsEndDate"
                >
                  End Date
                </label>
                <div className="event-my-earnings-date-control">
                  <input
                    id="eventMyEarningsEndDate"
                    className="event-my-earnings-input"
                    type="date"
                    name="endDate"
                    value={dateRange?.endDate || ""}
                    onChange={handleDateRange}
                  />
                  <i
                    className="bi bi-calendar3 event-my-earnings-date-icon"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
              <div className="event-my-earnings-field event-my-earnings-field--search">
                <span
                  className="event-my-earnings-label event-my-earnings-label--hidden"
                  aria-hidden="true"
                >
                  Search
                </span>
                <button
                  type="submit"
                  className="event-my-earnings-search-btn"
                  disabled={isLoading}
                >
                  Search
                </button>
              </div>
            </div>
            <div
              className="event-my-earnings-quick-filters"
              aria-label="Quick date filters"
            >
              {[
                { id: "today", label: "Today" },
                { id: "week", label: "Weekly" },
                { id: "month", label: "Monthly" },
              ].map((item) => (
                <button
                  key={item.id}
                  type="button"
                  className={`event-my-earnings-quick-btn${
                    timeSpanInput === item.id ? " is-active" : ""
                  }`}
                  disabled={isLoading}
                  onClick={() => handleTimeSpan(item.id)}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          {isMyEarningsPage && (
            <SearchSection
              handleSearchChange={handleSearchChange}
              searchInput={searchInput}
              isError={isError}
              isLoading={isLoading}
            />
          )}
        </form>
      )}

      {isShowDateFilter && !showEarningsFilters && (
        <form className="event-my-earnings-filters" onSubmit={handleDateRangeSubmit}>
          <div className="event-my-earnings-date-row">
            <div className="event-my-earnings-field">
              <label className="event-my-earnings-label">Start Date</label>
              <div className="event-my-earnings-date-control">
                <input
                  className="event-my-earnings-input"
                  type="date"
                  name="startDate"
                  value={dateRange?.startDate || ""}
                  onChange={handleDateRange}
                />
                <i
                  className="bi bi-calendar3 event-my-earnings-date-icon"
                  aria-hidden="true"
                ></i>
              </div>
            </div>
            <div className="event-my-earnings-field">
              <label className="event-my-earnings-label">End Date</label>
              <div className="event-my-earnings-date-control">
                <input
                  className="event-my-earnings-input"
                  type="date"
                  name="endDate"
                  value={dateRange?.endDate || ""}
                  onChange={handleDateRange}
                />
                <i
                  className="bi bi-calendar3 event-my-earnings-date-icon"
                  aria-hidden="true"
                ></i>
              </div>
            </div>
            <div className="event-my-earnings-field event-my-earnings-field--search">
              <button
                type="submit"
                className="event-my-earnings-search-btn"
                disabled={isLoading}
              >
                Search
              </button>
            </div>
          </div>
        </form>
      )}

      {isEarningDetailPage && (
        <div className="event-earning-detail-toolbar">
          {isOrganizerEarningDetailPage && (
            <div
              className="event-earning-detail-tabs"
              role="tablist"
              aria-label="Earning detail views"
            >
              {[
                { id: "ticket", label: "Tickets" },
                { id: "order", label: "Orders" },
                { id: "promoter", label: "Promoter" },
              ].map((tab) => (
                <button
                  key={tab.id}
                  type="button"
                  role="tab"
                  aria-selected={dataType === tab.id}
                  className={`event-earning-detail-tab${
                    dataType === tab.id ? " is-active" : ""
                  }`}
                  onClick={() => setDataType(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          )}
          <div
            className="event-earning-detail-periods"
            aria-label="Quick date filters"
          >
            {[
              { id: "today", label: "Today" },
              { id: "week", label: "Weekly" },
              { id: "month", label: "Monthly" },
            ].map((item) => (
              <button
                key={item.id}
                type="button"
                className={`event-earning-detail-period${
                  timeSpanInput === item.id ? " is-active" : ""
                }`}
                disabled={isLoading}
                onClick={() => handleTimeSpan(item.id)}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </MainComponentWrapper>
  );
};

Filter.defaultProps = {
  isShowDateFilter: false,
};

export default Filter;
